<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/mf_banner.png');">
          <div class="banner_item1_content">
            <p>移动消防勤务系统</p>
            <p class="txt1">
              具有防火巡查、信息采集、消防宣传、灭火救援四大职能
            </p>
            <div class="item1_infoBox mf_btnColor">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">方案背景</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">城中村、九小场所规模小、位置分布偏散，是所有小型人员密集场所的代名词，给实施安全监管带来困难。并且九小场所经营者大多自身消防安全意识和常识薄弱，对消防设施的建设维护投入严重不足，火灾安全隐患凸显，导致火灾时有发生。因此，有针对性地加强其消防安全管理成为当前消防安全管理工作中一个不可忽视的难点</span>
        </div>
        <div class="part1_itemBox">
          <div class="part1_item">
            <img src="static/image/mf_part1_bg1.png" alt="">
            <span>场所多隐患多监管力量小</span>
          </div>
          <div class="part1_item">
            <img src="static/image/mf_part1_bg2.png" alt="">
            <span>消防意识薄弱</span>
          </div>
        </div>
        <div class="part1_itemBox part1_itemBox1">
          <div class="part1_item">
            <img src="static/image/mf_part1_bg3.png" alt="">
            <span>管理不科学</span>
          </div>
          <div class="part1_item">
            <img src="static/image/mf_part1_bg4.png" alt="">
            <span>责任不明</span>
          </div>
        </div>
        <div class="part1_itemBox">
          <div class="part1_item">
            <img src="static/image/mf_part1_bg5.png" alt="">
            <span>安全数据管理不当</span>
          </div>
          <div class="part1_item">
            <img src="static/image/mf_part1_bg6.png" alt="">
            <span>机制不长效</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">方案简介</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">移动消防勤务系统：具有防火巡查、信息采集、消防宣传、灭火救援四大职能，另外移动消防勤务系统还可以和独立式火灾探测报警云平台、公安视频平台对接，实现九小场所的火灾报警信息推送和视频联动核实火情，使特勤人员能够第一时间赶赴现场扑救。</span>
        </div>
        <div class="part2_item">
          <div class="part2_itemInfo" v-for="(item,index) in partList" :key="index+'partList'" @mouseover="addActive($event,index)" @mouseleave="removeActive($event,index)">
            <img :src="item.imgSrc" alt="">
            <span :class="item.txtColor">{{item.txt}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">解决方案</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">主要实现责任范围管理、安全生产管理、隐患综合治理、一张图预警和综合管理等功能。其中安全生产管理又包括目标管理、管理架构、专项工作落实、安全生产责任制、领导责任落实、安全检查、宣传培训、设备管理、安全生产投入、职业卫生健康等功能。隐患综合治理包括隐患台账、隐患随手拍、整改派单、现场整改、整改审核和闭环存档。</span>
        </div>
        <div class="part3_img">
          <img src="static/image/mf_part3_bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_content_btn">
          主要功能框架
        </div>
        <div class="part5_content_item">
          <div>

          </div>
        </div>
        <div class="part5_content_item1">
          <div></div>
          <div class="part5_content_border"></div>
          <div></div>
          <div class="part5_content_border"></div>
          <div></div>
        </div>
        <div class="part5_content_item2">
          <div :class="item.bgColor" v-for="(item,index) in resultList" :key="index+'resultList'" @mouseover="addActive1($event,index)" @mouseleave="removeActive1($event,index)">
            <div>
              <img :src="item.normalSrc" alt="">
            </div>
            <span :class="item.txt1Class">{{item.txt1}}</span>
            <span :class="item.txt2Class" v-for="(item1,index1) in item.txt2" :key="index1">{{item1}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">消防一张图</p>
        <div class="part6_content_img">
          <img src="static/image/mf_part6_bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">建立全面的隐患分类机制</p>
        <div class="part6_content_img">
          <img src="static/image/mf_part6_bg2.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">城中村、九小场所责任类型自动鉴定</p>
        <div class="part6_content_img">
          <img src="static/image/mf_part6_bg3.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">建立场所巡查隐患积分机制</p>
        <div class="part6_content_img">
          <img src="static/image/mf_part6_bg4.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">物联探测报警</p>
        <div class="part6_content_txt1">
          集成独立式感烟探测器、电气火灾探测器、煤气探测报警信息、市政消火栓管网压力探测器，发生报警立即向相关责任人（九小场所业主、消防特勤、社区网格员）手机发短信、微信和电话通知，并向监控大屏发送语音提示通知，并发送火灾报警附近摄像头信息，收到报警信息后，可以通过手机、电脑打开火灾附近摄像头进行火警核实。平时也可以通过视频摄像头进行视频巡检。
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">场所责任人反馈评价功能</p>
        <div class="part6_content_img">
          <img src="static/image/mf_part6_bg5.png" alt="">
          <p class="part6_content_txt2">特勤服务评价</p>
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">九小场所信息采集、消防巡查周期化</p>
        <div class="part6_content_img">
          <img src="static/image/mf_part6_bg6.png" alt="">
          <p class="part6_content_txt2">场所隐患黑名单</p>
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">应用场景</span>
          <span class="part1_header_txt2">城中村、智慧园区、古镇景区、政府网格化巡查等</span>
        </div>
        <div class="part7_item">
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg1.png')">
            <p class="part7_item_txt">城中村</p>
          </div>
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg2.png')">
            <p class="part7_item_txt">智慧园区</p>
          </div>
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg3.png')">
            <p class="part7_item_txt">古镇景区</p>
          </div>
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg4.png')">
            <p class="part7_item_txt">政府网格化巡查</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">相关案例</span>
          <span class="part1_header_txt2">南京夫子庙、乌镇景区、月河历史街区等</span>
        </div>
        <div class="part7_item">
          <div class="part7_item_box1">
            <img src="static/image/mf_part8_bg1.png" alt="">
            <p class="part7_item_txt1">目前系统已经注册各分局管理员、派出所管理员、派出所消防民警、消防特勤共计494人</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/mf_part8_bg2.png" alt="">
            <p class="part7_item_txt1">采集消防水源108处。采集各类九小场所1054家，其中排查轻微隐患场所252家，一般隐患场所27家，严重隐患场所93家，并已完成隐患派单。</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/mf_part8_bg3.png" alt="">
            <p class="part7_item_txt1">通过大数据分析：场所分类主要以小餐馆和小商店为主，占比超过72%；隐患类型主要以液化石油气烧煮和电瓶车违规充电，占比超过38%</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part7_content">
        <div class="part7_leftBox">
          <img src="static/image/mf_part7_bg5.png" alt="">
          <div class="part7_leftBox_img1" style="background-image: url('static/image/mf_part7_bg6.png')">
            <div class="part7_leftBox_txt1">乌镇景区</div>
          </div>
          <div class="part7_leftBox_img2" style="background-image: url('static/image/mf_part7_bg7.png')">
            <div class="part7_leftBox_txt1">月河历史街区</div>
          </div>
        </div>
        <div class="part7_rightBox">
          <p class="part7_rightBox_txt1">夫子庙移动消防警务项目</p>
          <p class="part7_rightBox_txt2"></p>
          <p class="part7_rightBox_txt3">历年来，夫子庙秦淮灯会都是人员及其密集场所，每年接待人流总量超过60万，消防安保工作任务重、责任大。夫子庙核心景区内多为古建筑和仿古建筑，而且聚集着各类餐饮、商铺、娱乐场所，一直是火灾防控的重点单位。针对严峻的消防安全形势，南京市在“智慧消防”上狠下功夫，依靠物联网和云计算这两项核心技术，用高科技助力灯会安保</p>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>

</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "mobileFire",
    components: {HeaderCom, FooterCom, RegisterCom},
    data(){
      return{
        partList:[
          {
            imgSrc:"static/image/mf_part2_bg1.png",
            txt:"防火巡查",
            txtColor:"part2_itemInfo_txt1",
          },
          {
            imgSrc:"static/image/mf_part2_bg2.png",
            txt:"信息采集",
            txtColor:"part2_itemInfo_txt1",
          },
          {
            imgSrc:"static/image/mf_part2_bg3.png",
            txt:"消防宣传",
            txtColor:"part2_itemInfo_txt1",
          },
          {
            imgSrc:"static/image/mf_part2_bg4.png",
            txt:"灭火救援",
            txtColor:"part2_itemInfo_txt1",
          },

        ],
        resultList:[
          {
            normalSrc:"static/image/mf_part5_bg1.png",
            txt1:"消防责任落实",
            txt2:["消防值班","防火巡查","防火检查","设备维护","教育培训"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg2.png",
            txt1:"隐患排查治理",
            txt2:["现场整改","隐患上报","隐患随手拍","整改派单","核实闭环"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg3.png",
            txt1:"物联探测警报",
            txt2:["主机报警","液位报警","水压报警","电气火报警","煤气泄漏报警"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg4.png",
            txt1:"应急联动处理",
            txt2:["报警视频联动","视频巡查","应急预案","应急演习","应急处置"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg5.png",
            txt1:"一张图检测预警",
            txt2:["责任落实情况","防患治理情况","设备运行情况","火灾报警情况","火灾风险预测预警"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg6.png",
            txt1:"综合管理",
            txt2:["单位组织人员信息责任制","消防标准管理","重点部位MIP点码","消防工作计划管理","物联网参数"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
        ],
      }
    },
    methods:{
      addActive(e,index){
        this.partList[index].imgSrc = "static/image/mf_part2_bgActive"+(index+1)+".png";
        this.partList[index].txtColor = "part2_itemInfo_txt1 part2_itemInfo_txt1Ac";
      },
      removeActive(e,index){
        this.partList[index].imgSrc = "static/image/mf_part2_bg"+(index+1)+".png";
        this.partList[index].txtColor = "part2_itemInfo_txt1";
      },
      addActive1(e,index){
        this.resultList[index].normalSrc = "static/image/mf_part5_bg"+(index+1)+"Active.png";
        this.resultList[index].bgColor = "part5_item2_info part5_item2_infoActive";
        this.resultList[index].txt1Class = "part5_item2_txt1 part5_item2_txt1Active";
        this.resultList[index].txt2Class = "part5_item2_txt2 part5_item2_txt2Active";
      },
      removeActive1(e,index){
        this.resultList[index].normalSrc = "static/image/mf_part5_bg"+(index+1)+".png";
        this.resultList[index].bgColor = "part5_item2_info";
        this.resultList[index].txt1Class = "part5_item2_txt1";
        this.resultList[index].txt2Class = "part5_item2_txt2";
      },
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .mf_btnColor{
    background:rgba(80,21,168,1);
  }
  .part1Box{
    width:100%;
    height: 890px;
    display: flex;
    justify-content: center;
  }
  .part1_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part1_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part1_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 0 30px 0;
  }
  .part1_item{
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .part1_item img{
    width: 160px;
    height: 160px;
  }
  .part1_itemBox{
    width: 54%;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
  }
  .part1_item span{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:24px;
  }
  .part1_itemBox1{
    width: 100%;
    padding: 0;
  }
  .part2Box{
    width:100%;
    height:500px;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_item{
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .part2_itemInfo{
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    padding: 30px 0 0 0;
  }
  .part2_itemInfo_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    text-align: center;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .part2_itemInfo_txt1Ac{
    color: #2A62FF;
  }
  .part3Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part3_img{
    text-align: center;
  }
  .part5Box{
    width: 100%;
    height: 650px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:#ffffff;
  }
  .part5_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part5_content_btn{
    width:280px;
    height:60px;
    background:rgba(42,98,255,1);
    border-radius:5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part5_content_item{
    width: 1000px;
    height: 58px;
    border-bottom:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item>div{
    width: 50%;
    height: 100%;
    border-right:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item1{
    width: 1000px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_content_item1>div{
    flex: 1;
  }
  .part5_content_item2{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item2_info{
    width:180px;
    height:300px;
    background:rgba(240,240,240,1);
    border-radius:5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
    cursor: pointer;
    text-align: center;
  }
  .part5_item2_infoActive{
    background: #2A62FF;
  }
  .part5_item2_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_item2_txt1Active{
    color: #FFFF00;
  }
  .part5_item2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part5_item2_txt2Active{
    color: #FFFFFF;
  }
  .part5_content_border{
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
  .part6Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part6_content{
    width: 1200px;
  }
  .part6_content_txt{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(59,74,117,1);
    line-height:30px;
    padding: 30px 0;
  }
  .part6_content_img{
    text-align: center;
  }
  .part6_content_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part6_content_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part7Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .part7_item{
    width: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0 70px 0;
  }
  .part7_item_box{
    width:282px;
    height:180px;
    box-sizing: border-box;
    position: relative;
  }
  .part7_item_txt{
    width:100%;
    height:30px;
    background:rgba(0,0,0,0.5);
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
    text-align: center;position: absolute;
    z-index: 1;
    bottom: 0;
  }
  .part7_item_box1{
    width:380px;
    height:200px;
    background:rgba(238,242,254,1);
    box-sizing: border-box;
    padding:30px 30px 0 40px;
  }
  .part7_item_txt1{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part7_content{
    width: 1200px;
    box-sizing: border-box;
    display: flex;
    padding: 0 0 60px 0;
  }
  .part7_leftBox{
    width: 450px;
    height: 358px;
    position: relative;
  }
  .part7_leftBox_img1{
    width: 100%;
    height: 70px;
    position: absolute;
    z-index: 1;
    bottom: 70px;
  }
  .part7_leftBox_img2{
    width: 100%;
    height: 70px;
    position: absolute;
    z-index: 1;
    bottom: 0;
  }
  .part7_leftBox_txt1{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part7_rightBox{
    flex: 1;
    background:rgba(238,242,254,1);
    box-sizing: border-box;
    padding: 50px 30px;
  }
  .part7_rightBox_txt1{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part7_rightBox_txt2{
    width:50px;
    height:2px;
    background:rgba(59,74,117,1);
    border-radius:1px;
    box-sizing: border-box;
    margin: 30px 0;
  }
  .part7_rightBox_txt3{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/info/mobileFire.vue